import type { GetFeaturesInnerParams } from '@/app/components/search/components/EvolutionCard/Details/Features/getFeatures/types.ts';
import { type Feature, FeatureType } from '@/app/components/search/components/EvolutionCard/utils/facilitiesTypes.ts';

export const getSoldOutFeatures = ({ t, hasAlternativeDates, isOverlay }: GetFeaturesInnerParams): Feature[] => [
  {
    icon: { category: 'Semantics', name: 'icon-circle-warning', color: 'iconWarning' } as const,
    text: t('vacation.oss.cards.not_available_dates'),
    className: 'not-available',
    featureType: FeatureType.danger,
  },
  ...(hasAlternativeDates && !isOverlay
    ? [
        {
          icon: ``,
          text: t('vacation.oss.cards.available_dates'),
          className: 'not-available-alternative-dates',
          featureType: FeatureType.normal,
        },
      ]
    : []),
];
